import Rails from '@rails/ujs';

import ModuleLoader from './lib/module-loader';
import EnhancedSelect from './modules/enhanced-select';

Rails.start();

const isDevelopment = process.env.NODE_ENV === 'development';
const loader: ModuleLoader = new ModuleLoader({ debug: isDevelopment });

loader.register('enhanced-select', EnhancedSelect);

loader.run();
